import { gql } from '@apollo/client'

export const AUDIT_ATTRIBUTES = gql`
  fragment auditAttributes on AuditLog {
    id
    createdAt

    builderId
    project {
      name
    }
    projectId

    action

    actionBy
    actionByIdentity

    resource
    resourceIdentity

    newSnapshot
    oldSnapshot

    actionByLink {
      ... on WorkerAuditEntity {
        user {
          id
          firstName
          lastName
        }
      }
      ... on SubcontractorEntity {
        id
        name
      }
      ... on AdminUserEntity {
        user {
          id
          firstName
          lastName
        }
      }
    }
  }
`

const AUDIT_ATTRIBUTES_SUBSET = gql`
  fragment auditAttributesSubset on AuditLog {
    id
    createdAt

    project {
      name
      timezone
    }
    projectId

    action
    actionBy
    resource
    resourceIdentity
  }
`

export const GET_AUDIT = gql`
  query auditLog_UI($id: String!) {
    auditLog(id: $id) {
      ...auditAttributes
    }
  }
  ${AUDIT_ATTRIBUTES}
`

export const GET_AUDITS = gql`
  query auditLogs_UI {
    auditLogs {
      ...auditAttributes
    }
  }
  ${AUDIT_ATTRIBUTES}
`

export const GET_AUDITS_LIST = gql`
  query auditLogsList_UI {
    auditLogs {
      ...auditAttributesSubset
    }
  }
  ${AUDIT_ATTRIBUTES_SUBSET}
`

export const GET_AUDITS_BY_RESOURCE = gql`
  query auditLogsByResourceId_UI($id: String!, $pagination: PaginationInput) {
    auditLogsByResourceId(id: $id, pagination: $pagination) {
      ...auditAttributes
    }
    auditLogsByResourceIdAggregation(id: $id, pagination: $pagination) {
      totalCount
      totalPages
      offset
      limit
    }
  }
  ${AUDIT_ATTRIBUTES}
`

export const FIND_RESOURCE_BY_ID = gql`
  query findResourceById_UI($id: String!) {
    findResourceById(id: $id) {
      resource
      createdAt
      updatedAt
      archivedAt

      project {
        id
        name
      }

      builder {
        createdAt
        id
        company {
          name
        }
      }

      worker {
        id
        user {
          id
          firstName
          lastName
        }
      }

      user {
        id
        firstName
        lastName
      }

      adminUser {
        id
        user {
          id
          firstName
          lastName
        }
      }

      subcontractor {
        id
        company {
          name
        }
      }

      linkedResources {
        project {
          id
          name
        }

        builder {
          id
          company {
            name
          }
        }

        worker {
          id
          user {
            id
            firstName
            lastName
          }
        }

        user {
          id
          firstName
          lastName
        }

        adminUser {
          id
          user {
            id
            firstName
            lastName
          }
        }

        subcontractor {
          id
          company {
            name
          }
        }
      }
    }
  }
`
